import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";


import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Swal from "sweetalert2";



import MDBox from "components/MDBox";
import Breadcrumbs from "examples/Breadcrumbs";
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
} from "context";



function DashboardNavbar({ absolute, light, isMini }) {

  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, fixedNavbar } = controller;
  const location = useLocation();
  const route = location.pathname.split("/").slice(1);
  const [username, setUsername] = useState("");
  const [referralCode, setReferralCode] = useState("");


  useEffect(() => {
    if (fixedNavbar) setNavbarType("sticky");
    else setNavbarType("static");

    const role = localStorage.getItem("role");
    const email = localStorage.getItem("email");
    const name = localStorage.getItem("username");
    const code = localStorage.getItem("code");

    if (role === "Admin" || role === "Marketing Manager" || role === "Telecaller") {
      setUsername(email);
      setReferralCode(code || "N/A");
    } else {
      setUsername(email || name || "Guest");
      setReferralCode("");
    }

    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    window.addEventListener("scroll", handleTransparentNavbar);
    handleTransparentNavbar();

    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);


  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);


  const iconsStyle = {
    color: "#ffffff",
  };

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      sx={{

        background: "linear-gradient(45deg, #ee7a60 30%, #ee7a60 50%)",

        boxShadow: "0px 4px 12px -2px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        { }
        <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light />
        </MDBox>

        { }
        {!isMini && (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#ffffff",
                  padding: "6px 12px",
                  borderRadius: "30px",
                  transition: "background-color 0.3s ease-in-out",
                }}
              >

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

                  {/* ⭐ Referral Code Display - Separate Pill */}
                  {referralCode && (
                    <Box
                      sx={{
                        backgroundColor: "rgba(255,255,255,0.3)",
                        padding: "5px 12px",
                        borderRadius: "20px",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        color: "#fff",
                      }}
                    >
                      Referral: {referralCode}

                      <IconButton
                        sx={{
                          padding: "2px",
                          color: "#fff",
                          "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
                        }}
                        size="small"
                        onClick={() => {
                          navigator.clipboard.writeText(referralCode);
                          Swal.fire({
                            title: "Copied!",
                            text: "Referral code copied to clipboard",
                            icon: "success",
                            confirmButtonText: "OK",
                            position: "center",
                            backdrop: true,
                          });
                        }}

                      >
                        <Icon fontSize="small">content_copy</Icon>
                      </IconButton>

                    </Box>
                  )}


                  {/* 👤 Username Display */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      color: "#ffffff",
                      padding: "6px 12px",
                      borderRadius: "30px",
                    }}
                  >
                    <Icon sx={iconsStyle}>account_circle</Icon>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: "inherit" }}>
                      {username || "Guest"}
                    </Typography>
                  </Box>



                </Box>

              </Box>


              { }
              <IconButton
                size="medium"
                disableRipple={false}
                sx={{
                  ...navbarMobileMenu,
                  color: "#ffffff",
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.15)",
                  },
                }}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
            </Box>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}


DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;